import { Fragment, useEffect, useState } from "react";
import { Loader2, TrendingDown, AlertTriangle } from "lucide-react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine } from "recharts";
import { Money } from "./SaudiRiyal";
import { api } from "../lib/api";

const fmt = (v) => (v === undefined ? "—" : Math.round(v).toLocaleString("en"));

const Chart = ({ r, months }) => (
  <div className="h-40 w-full" dir="ltr" data-testid={`trend-chart-${r.employee_id}`}>
    <ResponsiveContainer>
      <LineChart data={months.map((m) => ({ m: m.slice(5), v: r.profits[m] ?? null }))}>
        <XAxis dataKey="m" fontSize={11} /><YAxis fontSize={10} width={45} /><Tooltip /><ReferenceLine y={0} stroke="#ef4444" strokeDasharray="3 3" />
        <Line type="monotone" dataKey="v" stroke="#059669" strokeWidth={2} connectNulls dot />
      </LineChart>
    </ResponsiveContainer>
  </div>
);

export const ProfitTrend = ({ month, refreshKey }) => {
  const [d, setD] = useState(null);
  const [sel, setSel] = useState("");
  useEffect(() => { setD(null); api.riderProfitTrend(month).then(setD).catch(() => setD({ months: [], riders: [] })); }, [month, refreshKey]);
  if (!d) return <div className="py-6 text-center text-slate-400"><Loader2 className="mx-auto h-5 w-5 animate-spin" /></div>;
  return (
    <div className="space-y-2" data-testid="profit-trend">
      <h4 className="font-heading font-bold text-slate-900 flex items-center gap-1.5"><TrendingDown className="h-4 w-4 text-red-500" /> اتجاه الربح — آخر 6 أشهر</h4>
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
        <table className="w-full text-sm text-right">
          <thead className="bg-slate-50 text-xs text-slate-500"><tr><th className="p-2">المندوب</th>{d.months.map((m) => <th key={m} className="p-2 whitespace-nowrap" dir="ltr">{m}</th>)}<th className="p-2">المجموع</th></tr></thead>
          <tbody>
            {d.riders.map((r) => (
              <Fragment key={r.employee_id}>
                <tr onClick={() => setSel(sel === r.employee_id ? "" : r.employee_id)} className="cursor-pointer border-t border-slate-100 hover:bg-slate-50" data-testid={`trend-row-${r.employee_id}`}>
                  <td className="p-2 font-semibold text-slate-800 whitespace-nowrap">{r.name}
                    {r.repeated_loss && <span className="ms-1 inline-flex items-center gap-0.5 rounded-full bg-red-100 px-1.5 py-0.5 text-[10px] text-red-700" data-testid={`trend-loss-${r.employee_id}`}><AlertTriangle className="h-3 w-3" /> خسارة متكررة</span>}</td>
                  {d.months.map((m) => <td key={m} className={`p-2 whitespace-nowrap ${r.profits[m] < 0 ? "bg-red-50 font-semibold text-red-600" : "text-slate-700"}`}>{fmt(r.profits[m])}</td>)}
                  <td className={`p-2 font-bold whitespace-nowrap ${r.total < 0 ? "text-red-600" : "text-emerald-700"}`}><Money value={r.total} /></td>
                </tr>
                {sel === r.employee_id && <tr><td colSpan={d.months.length + 2} className="p-2"><Chart r={r} months={d.months} /></td></tr>}
              </Fragment>
            ))}
            {!d.riders.length && <tr><td colSpan={8} className="p-6 text-center text-xs text-slate-400">لا توجد بيانات في الأشهر الستة الأخيرة</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};
